import React from 'react';

export default () => (
  <svg width="17" height="14" viewBox="-1 -1 19 16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <g stroke="#D6DCE4" fill="#FFF">
        <g>
          <path d="M1.147 13.285L8.462.336l7.366 13.037" />
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/arrow-up.es6.js